import React from "react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer className="relative bg-black border-t border-white/5">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-16 md:py-20 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <Logo />
          <p className="mt-6 text-neutral-500 text-[13px] leading-relaxed max-w-sm">
            Publicação editorial e histórica independente. Nossa missão é organizar fatos, acusações e
            decisões judiciais em um dossiê cronológico acessível.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-red-500 mb-5">
            Navegação
          </div>
          <ul className="space-y-3 text-[14px] text-neutral-300">
            {[
              { l: "Sobre", h: "#top" },
              { l: "Contato", h: "mailto:contato@dossiebrasil.com" },
              { l: "Compra", h: "#comprar" },
              { l: "Fontes", h: "#fontes" },
            ].map((x) => (
              <li key={x.l}><a href={x.h} className="hover:text-red-500 transition-colors">{x.l}</a></li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-red-500 mb-5">
            Legal
          </div>
          <ul className="space-y-3 text-[14px] text-neutral-300">
            <li>Política de Privacidade</li>
            <li>Termos de Uso</li>
            <li><a href="/admin" className="hover:text-red-500 transition-colors">Painel editorial</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10 py-8 text-[11px] font-mono tracking-[0.2em] text-neutral-500 leading-relaxed uppercase">
          Material informativo e histórico. Publicação independente, sem vínculo oficial com o
          Exército Brasileiro, a 11ª Região Militar, o Governo Federal ou qualquer partido político.
          © {new Date().getFullYear()} Dossiê Brasil.
        </div>
      </div>
    </footer>
  );
}
